// src/Payroll_Management/PayRoll_Report/EmployeeRemarksReportPrint.jsx
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://nissi-india.com";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

const EmployeeRemarksReportPrint = () => {
  const q = useQuery();
  const finYearId = localStorage.getItem("finYearId") || "";
  const empId = q.get("empId") || "";

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);

  const fetchAll = async () => {
    // Print wants ALL rows → loop pages if needed
    const pageSize = 200;
    let page = 1;
    let totalPages = 1;
    let all = [];

    while (page <= totalPages) {
      const res = await axios.get(`${BASE_URL}/api/employee-report/remarks`, {
        params: { finYearId: Number(finYearId), empId, page, pageSize },
      });

      if (!res?.data?.success) throw new Error(res?.data?.message || "Failed to load remarks");

      totalPages = Number(res.data.totalPages || 1);
      all = all.concat(res.data.rows || []);
      page += 1;
    }

    return all;
  };

  useEffect(() => {
    let alive = true;

    const run = async () => {
      try {
        setLoading(true);
        if (!String(finYearId).trim() || !String(empId).trim()) {
          setRows([]);
          setLoading(false);
          return;
        }

        const all = await fetchAll();
        if (!alive) return;

        setRows(all);
        setLoading(false);

        setTimeout(() => window.print(), 300);
      } catch (e) {
        if (!alive) return;
        console.error(e);
        setRows([]);
        setLoading(false);
      }
    };

    run();
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="print-root">
      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        }
        .print-root { padding: 14px; font-family: Arial, Helvetica, sans-serif; color: #000; }
        .sheet { border: 1px solid #000; padding: 10px; max-width: 980px; margin: 0 auto; }
        .title { text-align:center; font-weight:700; margin: 8px 0 12px; font-size: 16px; }
        table { width: 100%; border-collapse: collapse; font-size: 12px; }
        th, td { border: 1px solid #000; padding: 6px; }
        th { font-weight: 700; text-align: center; }
        td { text-align: center; }
      `}</style>

      <div className="no-print" style={{ display: "flex", gap: 10, maxWidth: 980, margin: "0 auto 10px" }}>
        <button onClick={() => window.print()} style={{ padding: "8px 14px", fontWeight: 700 }}>
          Print
        </button>
        <button onClick={() => window.close()} style={{ padding: "8px 14px", fontWeight: 700 }}>
          Close
        </button>
      </div>

      <div className="sheet">
        <div className="title">EMPLOYEE REMARKS REPORT (EmployeeID: {empId})</div>

        {loading ? (
          <div style={{ textAlign: "center", padding: 20 }}>Loading...</div>
        ) : rows.length === 0 ? (
          <div style={{ textAlign: "center", padding: 20 }}>No Records Found</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Employee Code</th>
                <th>Employee Name</th>
                <th>Date</th>
                <th>Title</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, idx) => (
                <tr key={`${r.fld_Remark_ID ?? idx}`}>
                  <td>{idx + 1}</td>
                  <td>{r.fld_Employeecode}</td>
                  <td style={{ textAlign: "left" }}>{r.fld_Employee}</td>
                  <td>{r.RemarkDate}</td>
                  <td style={{ textAlign: "left" }}>{r.fld_Title}</td>
                  <td style={{ textAlign: "left" }}>{r.fld_Details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default EmployeeRemarksReportPrint;
